import React, { useState, useEffect } from 'react';
import { Input } from '@chapche/ui';
import {Filter, ItemsStorageService} from "./filtering/itemsStorageService";
import { useTranslation } from 'react-i18next';

interface FiltersListItemMaxAndMinProps {
    itemsStorageService: ItemsStorageService,
    filterData: Filter,
}

const FiltersListItemMaxAndMin = ({ itemsStorageService, filterData }: FiltersListItemMaxAndMinProps) => {
    const { i18n } = useTranslation();
    const [inputValue, setInputValue] = useState({min: '', max: ''});

    const changeFilterValue = (e, filterKey) => {
        itemsStorageService.setNumberFilterValue(filterData.filterName, e.target.value);
        setInputValue({...inputValue, [filterKey]: e.target.value});
    };

    const getCurrentFilterValue = () => {
        setInputValue({...filterData});
    };

    useEffect(() => {
        itemsStorageService.registerFiltersChangingObserver(getCurrentFilterValue);
        setInputValue(filterData);
        return () => itemsStorageService.unRegisterFiltersChangingObserver(getCurrentFilterValue);
    }, []);

    return (
        <div key={filterData.filterName} className="block__content product__dropdown-label product__dropdown-number flex flex-col gap-8">
            <label className="product__dropdown-text flex flex-col gap-4">
                {i18n.t('product.scheme.property.code.from')}
                <Input
                    fullWidth
                    type="number"
                    placeholder="0"
                    onChange={(e) => changeFilterValue(e, 'min')}
                    value={inputValue.min || ''}
                />
            </label>
            <label className="product__dropdown-text flex flex-col gap-4">
                {i18n.t('product.scheme.property.code.to')}
                <Input
                    fullWidth
                    type="number"
                    placeholder="300000"
                    onChange={(e) => changeFilterValue(e, 'max')}
                    value={inputValue.max || ''}
                />
            </label>
        </div>
    );
};

export default FiltersListItemMaxAndMin;
